<template>
  <PartnerListWidget :href="actionLink" :openInNewTab="true" @click="onLinkClick">
    <template #icon>
      <HgIcon icon="PriceTag" size="large" theme="secondary" />
    </template>
    <template #content>
      <span>
        {{ t('integrations.ubsImmoCheck.textLabel') }}
        <span :class="$style.cta">
          {{ t('integrations.ubsImmoCheck.linkLabel') }}
        </span>
      </span>
    </template>
  </PartnerListWidget>
</template>

<script lang="ts" setup>
import { HgIcon } from '@smg-real-estate/domus';
import { Listing } from '@smg-real-estate/hg-rets-schema';
import { computed } from 'vue';

import PartnerListWidget from '@/components/PartnerIntegrations/PartnerListWidget/PartnerListWidget.vue';
import { InteractionGoal } from '@/helpers/GTM/GTMParameters';
import { trackNewImmocheckInteraction } from '@/helpers/GTM/GTMTrack';

import { useI18n } from 'vue-i18n';
import { getActionLink } from './functions';

defineOptions({
  name: 'UbsImmoCheck',
});

const { t, locale } = useI18n();

interface Props {
  listing: Listing;
}
const props = defineProps<Props>();

const emit = defineEmits<{
  trackPartnerLink: [link: string, goal: InteractionGoal];
}>();

const actionLink = computed(() => {
  return getActionLink(locale.value, props.listing?.id);
});

const onLinkClick = () => {
  // Always emit the existing tracking event for backwards compatibility
  emit('trackPartnerLink', actionLink.value, InteractionGoal.MARKET_VALUE_LOCATION_CHECK);

  // Add new tracking specifically for NEW_IMMOCHECK 2.0 feature
  trackNewImmocheckInteraction(actionLink.value);
};
</script>
<style lang="scss" module>
@import '@/assets/variables';

.cta {
  color: var(--base-color-link);

  @include font-bold;
}
</style>
